var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_49",
    "data-name": "Gruppe 49",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.395,
    height: 13.698,
    viewBox: "0 0 23.395 13.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_36",
    "data-name": "Gruppe 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    className: "cls-1",
    d: "M125.393,142.806l-9.8-9.8a1.958,1.958,0,0,0-2.762,0l-9.8,9.8a1.959,1.959,0,0,0,2.762,2.762l8.4-8.4,8.424,8.4a1.953,1.953,0,1,0,2.762-2.762Z",
    transform: "translate(-102.568 -132.441)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/ArrowUpIcon.753c6d928036bbe8d7000c170c53099d.svg";
export { ForwardRef as ReactComponent };